import React from 'react';
import { Create, useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Form from './detail/Form';
import Aside from './detail/Aside';

const useStyles = makeStyles({
  left: {
    width: 'calc(100% - 350px)',
  },
});

const LeaveCreate = (props) => {
  const classes = useStyles();
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.create', {
      resource: translate('resources.leave.name', { smart_count: 1 }),
    }),
  );

  return (
    <Create {...props} className={classes.left}>
      <Form aside={<Aside />} />
    </Create>
  );
};

export default LeaveCreate;
